module.exports = __webpack_public_path__ + "img/20200514_141416.78b9335a.jpg";